import { configureStore } from "@reduxjs/toolkit";
import { partnerPreferencesApi } from "Features/PartnerPreferences";
import { reducer as formReducer } from "redux-form";

import { siteConfigSlice } from "Common/Redux/siteConfig";

import { largeGroupSurveyApi } from "./api";

export const reducerSlices = {
  form: formReducer,
  [siteConfigSlice.name]: siteConfigSlice.reducer,
  [largeGroupSurveyApi.reducerPath]: largeGroupSurveyApi.reducer,
  [partnerPreferencesApi.reducerPath]: partnerPreferencesApi.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(largeGroupSurveyApi.middleware).concat(partnerPreferencesApi.middleware),
    preloadedState,
  });

  return store;
};
